import React from 'react';
import ReactDOM from 'react-dom';
// eslint-disable-next-line import/no-unresolved
import Index from './app/index';

import * as serviceWorker from './service-worker';

ReactDOM.render(<Index />, document.getElementById('root'));

serviceWorker.unregister();
